"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/Item.css");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
* Nom : ItemDoc.js
* Description : Ce fichier contient la définition du composant ItemDoc
*               Ce composant est un cadre avec un titre au dessus pour afficher un élément d'une liste de document
* Date de création : 26 septembre 2025
*/

/* CSS et assets */

/* Bibliothèques et composants */

/* Hook */
// None

/**
* ItemDoc : ce composant est un cadre avec un titre au dessus pour afficher un élément d'une liste de document
*
* Type : composant 
*
* Parametres : 
*  - children -- contenu de l'élément à afficher
*/function ItemDoc(_ref) {
  var titre = _ref.titre,
    children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
      children: titre
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "item-border",
      children: children
    })]
  });
}

// Les propTypes permettent de sécuriser les données en specifiant le type de donnée attendu pour une prop
ItemDoc.propTypes = {
  id: _propTypes["default"].number
};
var _default = exports["default"] = ItemDoc;